import { useState } from 'react';
import { useExpressCheckoutButtonsData } from '../../provider/useExpressCheckoutButtonsData';
const shouldDisplayCheckoutErrorModal = _ref => {
  let {
    isDisplayErrorModalsEnabled,
    isLiveSite
  } = _ref;
  return isDisplayErrorModalsEnabled && !isLiveSite;
};
export const useCheckoutErrorModal = _ref2 => {
  let {
    isShippable
  } = _ref2;
  const data = useExpressCheckoutButtonsData();
  const [isCheckoutErrorModalOpen, setIsCheckoutErrorModalOpen] = useState(false);
  const shouldDisplay = shouldDisplayCheckoutErrorModal({
    isDisplayErrorModalsEnabled: (data == null ? void 0 : data.isDisplayErrorModalsEnabled) ?? false,
    isShippable,
    isLiveSite: (data == null ? void 0 : data.isLiveSite) ?? true
  });
  return {
    isCheckoutErrorModalOpen,
    openCheckoutErrorModal: () => setIsCheckoutErrorModalOpen(true),
    closeCheckoutErrorModal: () => setIsCheckoutErrorModalOpen(false),
    shouldDisplayCheckoutErrorModal: shouldDisplay
  };
};
//# sourceMappingURL=useCheckoutErrorModal.js.map